<template>
    <div :class="['reviews-card']">
        <div class="reviews-card__inner">
            <ReviewsSmallCard :photo="photo"
                              :author="author"
                              :company="company"
                              :position="position"
                              :date="date"
                              :text="text"/>
            <div class="reviews-card__replies" v-if="dataReplies">
                <ReviewsSmallCard v-for="(reply, key) in dataReplies"
                                  :key="key"
                                  class="mb-4"
                                  :photo="reply.photo"
                                  :author="reply.author"
                                  :company="reply.company"
                                  :position="reply.position"
                                  :date="reply.date"
                                  :text="reply.text"
                />
            </div>
            <div v-if="rapliseble?.btnTitle" class="action-text reviews-card__replyBtn" @click="ClickToReplyBtn">
                {{rapliseble?.btnTitle}}
            </div>
            <AInput label="Введите коммент" v-model="reply" v-show="replyFormOpened" class="mb-5" />
        </div>
    </div>
</template>

<script>
import {ref} from 'vue';
import { AInput } from '../ui'
import ReviewsSmallCard from "./ReviewsSmallCard";
import {send} from '~/services/api'
/**
 * Карточка с возможнстью добавления отзыва https://i.imgur.com/4Cud1mz.png
 * */

export default {
    name: 'ReviewsCard',
    components: {ReviewsSmallCard, AInput},
    props: {
        author: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '',
        },
        company: {
            type: String,
            default: '',
        },
        position: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        photo: {
            type: String,
            default: '',
        },
        rapliseble:{
            default:{}
        },
        replies: {
            type: Array,
            default: () => []
        }
    },
    setup: (props, ctx) => {

        const replyFormOpened = ref(false);
        const dataReplies = ref(props.replies);
        const reply = ref('');
        const ClickToReplyBtn = async () => {
          if (!replyFormOpened.value) {
            replyFormOpened.value = true;
          } else if (reply.value.length > 1) {
            let formData = {};
            for (let key in props?.rapliseble?.action?.data) {
              formData[key] = props?.rapliseble?.action?.data[key];
            }
            formData['text'] = reply.value;
            await send(props?.rapliseble?.action?.link, {method: "post"}, formData).then((response) => {
              if(response.success) {
                showNotification('success','',response.success);
                if(response.reply) {
                  dataReplies.value.push(response.reply);
                  replyFormOpened.value = false;
                }
              } else {
                showNotification('danger','',response.error);
              }
            });
          }
        }

      return {ClickToReplyBtn, replyFormOpened, reply,dataReplies}
    },
}
</script>

<style lang="scss" scoped>
</style>
